var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_37_773",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_37_773",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE9klEQVR4nO2dS2hcVRjHT5SCqKggirgQceNC8IFrtcVFFwqCIkKNtT5wYZdpOecmlsTaalTEhasWlOKL2lSxG7FFoogLxS5szrlJmtJOMplJ84AYG5smk2Q+OXdunGma3DnzuufMnf8PPm6YMHfmfP/7/87jXuYwBgAAAAAAAAAAAABAq8L9RxgfaGdcdTCheCKDq46gjZ3qYeYkHX/dxITax4QcY0JRSwWXo0zIriAHTuD5TzIhL1pPjLAuzATjcqtdMbjaxbhatp4M4UzkGJc7LYnhP864XHIgCeRY5Jgnt8UrRre6GWVKRYgis6z79I3xCRJ04NavRHI6uOyMSQ1qY1ylrTdYNMHoS+cqlnmG7caKJgkuH2q8IEK+ZL2homnixcYLwuVeBxpKTRE6VzEI0lPdF5Th0S/5wura10SCQufKXUFCUfiaMKVC6KNPzHMgiYkXxCte/U8dGaOTI/M0u7BCi8t5OjuzRAf7p+m2nqGrRRMOJDOxgoTx3s8ztBkjM0t018Fh+wlsFUGePjJG5TgxeCl5/YmTgnBJp0bmywqSzxPd+/7ZQokrKXNNHU4KIhT9fWWFTHjh63H7SWwFQXQHbsKrx7P2k5hsQQrDWX9q0UiQJw6lSt7nQEKTJ0gh3v5puqwY6bkcbekaTNbQ11WH3NI9GAxtozr0Zz4fS44z3BVkTRRFd787HEwK1zM+lwvFKIzIrCcx8YKsWw65/6Nz1P5Nhl7pywR9RqFM+ckTQ7gqSCsHbwpBLPUTHgSxf4V6JReBt3YxyOLr64+t4pA3vssaxQMfn9twyHvfByPG57jhrVIHFv/e0uXTo5+cp2e/SNNrx7P08rFMsPqsX9P/a4iTXBXElN0nJjYU5Pmv0sbnuOOdq1eN9cChT/5DC7nVTd9zaXE1WNzUn3NdPdfRIAj9L8itPUN09MwcVcqZi1do2+FUOOqrceQHQSgQ5M4Dw8bLNRuxvJqnN7+fCBNbgygQhIIJ6O/pBaoHXSen4BBWYx/y6Z+zVC/0ks72z0bhEFaDIPUmNRsuelYz+kLJagw7jlZ54wyCNIbTmQUIwupQsvSS/4H+6WAS+Pq3Wer9ZYaGpqsbfenJacX3++GQYmfs/ThJ13eGD+CVJKlNKNrVl6HLERPFjdh5LIOSxap0yL5TU5tP7MLOeevhVDDfMOXQH7MQhFUhiK73bUYlRQYlzJTfRi+HIqNkUSWCPPdlOnRG+Rm2ntGbPhEzOLUIh7AqHHJPb/iwnVmnS/3n/zU67+T8MgRhVQhy+/7SB7ejS5Y+fvirWdlaWslDENZQQQqx94dJ45EbJoai9vsh5Vyi78FAkBhvUDEIcm0STNkNQZJ/C5fBIRCEYS2rCByCkkVY7Y0ADoFDCA6JAA6BQwgOiQAOgUMIDokADoFDCA6JAA6BQwgOiQAOaRGHaBJzC7eykA08d8yf5aQgXoUhZB3OUYEgDTt3fILgZ2KFUz8TO9AeX0lRzR1c7Wi8IHqbH9sNFU0S3sCDLBa4umC9scL1kCkWG3rPJesNVq6HF58gegMsveeS/UaTozEe74YuGs9/DFseqc32obK0OZjeAEt/AftXJDkRek8uPQq1ir4a9J5LtpMhrMd4sFGaE+h6qfdc0iOLlnOF0iNOL/4+wxS9zU8weZR7mJC9CY09QRtjm2cAAAAAAAAAAAAAAMCc4z9Fxao/b5koUwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.aeb937881f40e4d4a2adc9c00a2e1b4e.svg";
export { ForwardRef as ReactComponent };